import React from 'react';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonInput,
  IonItem,
  IonLabel,
  IonSpinner,
  IonText,
} from '@ionic/react';

interface ForgotPasswordFormProps {
  email: string;
  username: string;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onUsernameChange: (value: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  email,
  username,
  isLoading,
  onEmailChange,
  onUsernameChange,
  onSubmit,
  onCancel,
}) => {
  const loginCardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
  };

  const loginItemStyle: React.CSSProperties = {
    marginBottom: '1rem',
  };

  const loginButtonStyle: React.CSSProperties = {
    marginTop: '1.5rem',
    height: '48px',
    fontWeight: 600,
  };

  return (
    <IonCard style={loginCardStyle}>
      <IonCardHeader>
        <IonCardTitle>Forgot Password / Username</IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonText color="medium">
          <p style={{ marginTop: 0, lineHeight: 1.5 }}>
            If you have forgotten your user name, input your email address. You will receive an email providing you with your user name(s).
          </p>
        </IonText>

        <IonItem style={loginItemStyle}>
          <IonLabel position="stacked">Email</IonLabel>
          <IonInput
            value={email}
            placeholder="Enter your Email Address"
            onIonInput={(e) => onEmailChange(e.detail.value ?? '')}
            onKeyUp={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
            disabled={isLoading}
            clearInput
          />
        </IonItem>

        <IonText color="medium">
          <p style={{ marginTop: 0, lineHeight: 1.5 }}>
            If you know your user name but have forgotten your password, input your user name
          </p>
        </IonText>
        <IonItem style={loginItemStyle}>
          <IonLabel position="stacked">Username</IonLabel>
          <IonInput
            value={username}
            placeholder="Enter your User Name"
            onIonInput={(e) => onUsernameChange(e.detail.value ?? '')}
            onKeyUp={(e) => {
              if (e.key === 'Enter') onSubmit();
            }}
            disabled={isLoading}
            clearInput
          />
        </IonItem>

        <IonButton expand="full" onClick={onSubmit} disabled={isLoading} style={loginButtonStyle}>
          {isLoading ? (
            <>
              <IonSpinner name="crescent" />
              <span style={{ marginLeft: '8px' }}>Sending...</span>
            </>
          ) : (
            'Send'
          )}
        </IonButton>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <IonButton fill="clear" size="small" onClick={onCancel} disabled={isLoading}>
            Cancel
          </IonButton>
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export default ForgotPasswordForm;
